/**
 * Format Malaysian phone number as user types.
 * Output: 012-345 6789 or 03-1234 5678
 * Strips all non-digits, then applies formatting.
 */
export function formatPhoneNumber(value) {
    let digits = (value || '').replace(/\D/g, '');

    // Strip country code 60 → 0
    if (digits.startsWith('60') && digits.length > 4) {
        digits = '0' + digits.slice(2);
    }

    // Mobile: starts with 01 (e.g., 012, 011, 013, etc.)
    if (digits.startsWith('01')) {
        if (digits.length <= 3) return digits;
        if (digits.length <= 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
        return `${digits.slice(0, 3)}-${digits.slice(3, 7)} ${digits.slice(7, 11)}`;
    }

    // Landline: starts with 0 (e.g., 03, 04, etc.)
    if (digits.startsWith('0')) {
        if (digits.length <= 2) return digits;
        if (digits.length <= 6) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
        return `${digits.slice(0, 2)}-${digits.slice(2, 6)} ${digits.slice(6, 10)}`;
    }

    return digits;
}

/**
 * Strip formatting and return raw digits for storage.
 */
export function stripPhoneFormat(value) {
    return (value || '').replace(/\D/g, '');
}
